import { useQuery } from '@tanstack/react-query'
import debounce from 'lodash.debounce'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Header from '@components/header'
import Layout from '@components/Layout'
import ViewPurchasesModal from '@components/Modal/ViewPurchasesModal'
import { columnPurchaseInvoices } from '@utils/columns'
import { downloadExcel } from '@utils/downloadPdf'
import { fetchPurchasesWithPageSize } from '@utils/fetchData'
import { getToday } from '@utils/time'

const PurchaseInvoices = () => {
	const { t } = useTranslation()
	const formattedDate = getToday()
	const roleNames = useSelector((state) => state.main.roleNames)

	const [currentPage, setCurrentPage] = useState(0)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [docNum, setDocNum] = useState('')
	const [cardName, setCardName] = useState('')
	const [slpName, setSlpName] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(formattedDate)
	const [furaNum, setFuraNum] = useState('')
	const [invoiceNum, setInvoiceNum] = useState('')
	const [loadingExcel, setLoadingExcel] = useState(false)

	const { data = [], isLoading } = useQuery({
		queryKey: [
			'purchaseInvoice',
			currentPage,
			cardName,
			docNum,
			startDate,
			endDate,
			slpName,
			'',
			'api/purchase/tugallangan-haridlar',
			furaNum,
			invoiceNum,
		],
		queryFn: fetchPurchasesWithPageSize,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
	})

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleRowClick = (record) => {
		setSelectedRowData(record)
		setIsModalVisible(true)
	}
	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const debouncedSet = debounce((val, setState) => {
		setState(val)
	}, 500)

	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setCardName)
	}
	const handleSlpNameChange = (val) => {
		debouncedSet(val, setSlpName)
	}

	const handleInvoiceNumChange = (val) => {
		debouncedSet(val, setInvoiceNum)
	}
	const handleFuraNumChange = (val) => {
		debouncedSet(val, setFuraNum)
	}

	const columns = columnPurchaseInvoices(
		t,
		handleRowClick,
		handleDocNumChange,
		handleCardNameChange,
		handleSlpNameChange,
		handleFuraNumChange,
		handleInvoiceNumChange,
		roleNames.includes('Supplier') ? true : false,
	)

	const handleDownloadExcel = () => {
		downloadExcel({
			url: 'api/excelgenerators/export-purchase-invoices',
			params: {
				cardName,
				docNum,
				startDate,
				endDate,
				slpName,
				furaNum,
				invoiceNum,
				pageSize: 1000,
				pageToken: 0,
			},
			fileName: 'Yakunlangan buyurtmalar',
			onLoadingChange: setLoadingExcel,
		})
	}

	return (
		<Layout>
			<Header
				title={'purchase-invoices'}
				currentPage={currentPage + 1}
				handlePreviousPage={handlePreviousPage}
				handleNextPage={handleNextPage}
				hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onStartDateChange={handleStartDate}
				onEndDateChange={handleEndDate}
				startDate={startDate}
				endDate={endDate}
				formattedDate={formattedDate}
				isSticky={false}
				isShowExcelBtn
				handleDownloadExcel={handleDownloadExcel}
				loadingExcel={loadingExcel}
			/>
			<ViewPurchasesModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => setIsModalVisible(false)}
				isShowIncomingTab={true}
				isShowLandedCostTab={true}
				isShowLandedCosts={false}
				isShowPriceAtWhs={true}
				{...(roleNames.includes('admin') ||
				roleNames.includes('Supplier')
					? { showPayment: true }
					: {})}
					isShowPaymentTab
				isShowDocRate={true}
			/>
		</Layout>
	)
}

export default PurchaseInvoices
